import React from "react";
import { Link } from "react-router-dom";

export default function destinosSecundariosSeleccion({ hasTitle, bgColor }) {
  return (
    <>
      <section id="team" className={`team-member-section ptb-100 ${bgColor}`}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-5">
                {hasTitle ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Elegí tu destino
                  </span>
                ) : (
                  ""
                )}
                <h2>Viaje de Egresados para Secundarios</h2>
                <p className="lead">
                  Un viaje de egresados a destinos inolvidables: aventura,
                  amistad y recuerdos únicos en paisajes que marcarán tu vida
                  para siempre.
                </p>
              </div>
            </div>
          </div>
          <div
            className="row  justify-content-center"
            style={{ display: "flex" }}
          >
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minibariloche.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Bariloche</h5>
                  <h6>Nieve,cerros y lagos</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/bariloche"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span className="ti-arrow-right"></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minivillacarlozpaz.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Villa Carlos Paz</h5>
                  <h6>Lago-Sierras</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/villa-carlos-paz-secundarios"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span className="ti-arrow-right"></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minicostaatlantica.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Costa Atlántica</h5>
                  <h6>Mar</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/costa-atlantica-secundarios"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span className="ti-arrow-right"></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minicamboriu.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Brasil</h5>
                  <h6>Playa</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/brasil"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span className="ti-arrow-right"></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
